import {NgModule} from '@angular/core';
import {DistributedStreamingRegistryService, StreamingModule} from '../../streaming';
import {SubscriptionStreamingService} from '../../streaming/subscription-streaming.service';
import {DexComputedHeldPositionService} from './computed/dex-computed-held-position.service';
import {DexComputedLpService} from './computed/dex-computed-lp.service';
import {DexComputedTradableService} from './computed/dex-computed-tradable.service';
import {DexComputedTrancheRulesService} from './computed/dex-computed-tranche-rules.service';
import {DexComputedTrancheService} from './computed/dex-computed-tranche.service';
import {DexPosFramesStreamingService} from './dex-pos-frames-streaming.service';
import {DexStreamingService} from './dex-streaming.service';
import {DexMdSubjectService} from './subjects/dex-md-subject-service';
import {DexOrderTxSubjectService} from './subjects/dex-order-tx-subject-service';
import {DexSecuritiesSubjectService} from './subjects/dex-securities-subject-service';
import {DEX_STREAMING_SUBJECTS_INJECTION_TOKEN} from './subjects/dex-subjects-injection';
import {DexTransactionsSubjectService} from './subjects/dex-transactions-subject-service';

const getDexStreamingInjector = (
    distributedStreamingRegistryService: DistributedStreamingRegistryService
) =>
    distributedStreamingRegistryService
        .getStreamingServiceInjector('dexStreaming');

@NgModule({
    imports: [
        StreamingModule
    ],
    providers: [
        {
            provide: DexStreamingService,
            useFactory: (
                         distributedStreamingRegistryService: DistributedStreamingRegistryService
                     ) => {
                const injector = getDexStreamingInjector(distributedStreamingRegistryService);

                return new DexStreamingService(
                    injector.get(SubscriptionStreamingService),
                    injector.get(DEX_STREAMING_SUBJECTS_INJECTION_TOKEN)
                );
            },
            deps: [DistributedStreamingRegistryService]
        },
        DexSecuritiesSubjectService,
        {
            provide: DEX_STREAMING_SUBJECTS_INJECTION_TOKEN,
            useExisting: DexSecuritiesSubjectService,
            multi: true
        },
        DexMdSubjectService,
        {
            provide: DEX_STREAMING_SUBJECTS_INJECTION_TOKEN,
            useExisting: DexMdSubjectService,
            multi: true
        },
        DexTransactionsSubjectService,
        {
            provide: DEX_STREAMING_SUBJECTS_INJECTION_TOKEN,
            useExisting: DexTransactionsSubjectService,
            multi: true
        },
        DexOrderTxSubjectService,
        DexComputedTradableService,
        DexComputedTrancheService,
        DexComputedHeldPositionService,
        DexComputedLpService,
        DexComputedTrancheRulesService,
        {
            provide: DexPosFramesStreamingService,
            useFactory: (
                         distributedStreamingRegistryService: DistributedStreamingRegistryService
                     ) => {
                const injector = getDexStreamingInjector(distributedStreamingRegistryService);

                return new DexPosFramesStreamingService(
                    injector.get(SubscriptionStreamingService)
                );
            },
            deps: [DistributedStreamingRegistryService]
        }
    ]
})
export class DexStreamingModule {}
